import React from "react";

export const PlayIcon = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 800"
    >
      <defs></defs>
      <circle className="cls-1" cx="399.63" cy="400.43" r="386.5" />
      <path
        id="Polygon_1"
        data-name="Polygon 1"
        className="cls-2"
        d="M565.24,400.78l-269,163.33V237.45Z"
      />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitTraining/components/TTTElement/icons/PlayIcon.js